import * as R from 'ramda';
import {
  FutureStockSkuDTO,
  GridItemSkuDTO,
  InfinitePreOrderSkuDTO,
  MaterialPreOrderSkuDTO,
  ProductAvailabilityGridDTO,
  ReadyForDeliverySkuDTO,
} from '../../../products/details/productDetails.types';
import { OrderProductGridItem } from '../orderProducts.types';

interface FormatGridItemSkuToGridItemProps {
  sku: GridItemSkuDTO;
  resetOrderItem?: boolean;
}

interface FormatOrderProductGridDTO {
  productAvailability: ProductAvailabilityGridDTO;
  resetOrderItem?: boolean;
}

export const formatGridItemSkuToGridItem = ({
  sku,
  resetOrderItem,
}: FormatGridItemSkuToGridItemProps): OrderProductGridItem => ({
  skuKits: sku.skuKits || [],
  available: sku?.available,
  availableForReadyForDeliveryWithoutStock: !!(sku as ReadyForDeliverySkuDTO)
    ?.availableForReadyForDeliveryWithoutStock,
  deliveryWindowAvailable: !!(
    sku as InfinitePreOrderSkuDTO | MaterialPreOrderSkuDTO | FutureStockSkuDTO
  )?.deliveryWindowAvailable,
  orderWholeSalePrice: sku?.orderWholeSalePrice || 0,
  orderPromotionalPrice: sku?.orderPromotionalPrice,
  productSizeId: sku?.size.id,
  productSizeName: sku?.size.name,
  productSizeUnique: sku?.size.unique,
  productSizePosition: sku?.size.position,
  skuId: sku?.skuId,
  orderItemId: resetOrderItem ? undefined : sku?.orderItemId,
  orderItemQuantity: resetOrderItem ? 0 : sku?.orderItemQuantity || 0,
  orderItemKitId: sku.orderItemKitId,
  canceledQuantity: sku.canceledQuantity,
  pendingQuantity: sku.pendingQuantity,
  settledQuantity: sku.settledQuantity,
  reservedQuantity: sku.reservedQuantity,
  productSizeActive: sku.productSizeActive,
  stock: {
    availableAmount: (sku as ReadyForDeliverySkuDTO | FutureStockSkuDTO | MaterialPreOrderSkuDTO)
      ?.availableAmount,
    availableForSale: (sku as ReadyForDeliverySkuDTO | FutureStockSkuDTO | MaterialPreOrderSkuDTO)
      ?.availableForSale,
  },
  orderConditionId: sku.orderConditionId,
  priceComposition: sku.priceComposition,
});

export const formatOrderProductGridDTO = ({
  productAvailability,
  resetOrderItem,
}: FormatOrderProductGridDTO): OrderProductGridItem[] => {
  if (R.isEmpty(productAvailability.skus)) {
    return [];
  }

  return productAvailability.skus
    .filter((sku) => !!sku?.size?.id)
    .map((sku) =>
      formatGridItemSkuToGridItem({
        sku,
        resetOrderItem,
      }),
    );
};
